import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// Remove useTopics if not using it
// import { useTopics } from '../../context/TopicContext';
import { useToast } from '../../context/ToastContext';
import api from '../../services/api';
import { Panel, Form, Input, Button, ButtonGroup, Field } from '../common/controls';

const EditTopic = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [topicName, setTopicName] = useState('');

  useEffect(() => {
    const fetchTopic = async () => {
      try {
        const response = await api.get(`/topics/${id}`);
        setTopicName(response.data.name);
      } catch (error) {
        showToast('Failed to fetch topic', 'error');
        navigate('/');
      }
    };

    fetchTopic();
  }, [id, navigate, showToast]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/topics/${id}`, { name: topicName });
      showToast('Topic updated successfully', 'success');
      navigate(`/topic/${id}`);
    } catch (error) {
      showToast(error.response?.data?.message || 'Failed to update topic', 'error');
    }
  };

  return (
    <Panel>
      <h2>Edit Topic</h2>
      <Form onSubmit={handleSubmit}>
        <Field>
          Topic name
          <Input
            type="text"
            autoFocus
            value={topicName}
            onChange={(e) => setTopicName(e.target.value)}
            required
          />
        </Field>
        <ButtonGroup>
          <Button type="button" $secondary onClick={() => navigate(`/topic/${id}`)}>
            Cancel
          </Button>
          <Button type="submit">Save Changes</Button>
        </ButtonGroup>
      </Form>
    </Panel>
  );
};

export default EditTopic; 